import React, {Component} from 'react';
import {Col, Panel, Row, Table} from 'react-bootstrap';
import {fetch_mockups_by_category} from './actions';

class Mockups extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mockups : []
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.category_id != prevProps.match.params.category_id) {
            var mockup_data = fetch_mockups_by_category(this.props.match.params.category_id)
            this.setState({
                mockups : mockup_data
            })
        }
    }

    generate_row = (mockup, index) => {
        return  (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{mockup.name}</td>
              <td>{mockup.height}</td>
              <td>{mockup.width}</td>
            </tr>
        );
    }

    generate_mockup_table = () => {
        var final_html = [];

        this.props.mockups.map((mockup, index) => {
            final_html.push(this.generate_row(mockup, index));
        })

        return final_html
    }


    generate_body = () => {
        var final_html = [];
        if (this.props.mockups.length) {
            return (
                <Panel.Body >
                    <Row>
                        <Col className="text-center" xs={12}>
                            <h4>Mockup List</h4>
                        </Col>
                    </Row>
                    <br />
                    <Table striped bordered condensed hover>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Height</th>
                          <th>Width</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.generate_mockup_table()}
                      </tbody>
                    </Table>
                </Panel.Body>
            )
        }
    }

    render() {

        return (
            <div>
                <Panel>
                    {this.state.mockups&&this.state.mockups[0]&&this.state.mockups[0].name?this.state.mockups[0].name:''}
                </Panel>
            </div>
        );
          
    }
}

export default Mockups;